// src/framework/app/app.data.context.tsx
import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { AppContext } from './app.context.provider';
import AppContextProviderRegistry, { AppContextProvider } from './app.context.provider';
import { ApiRequestOptions } from '../../api-clients/composition/core/ApiRequestOptions';
import { OpenAPI } from '../../api-clients/composition';
import { getConfig } from '../config/app.config';


interface AppDataContextType {
  appContext: AppContext | undefined;
  setAppContext: React.Dispatch<React.SetStateAction<AppContext | undefined>>;
  apiUrl: string;
}

type Resolver<T> = (options: ApiRequestOptions) => Promise<T>;

// Create the context with a default value of undefined
const AppDataContext = createContext<AppDataContextType | undefined>(undefined);

// Custom hook to access the AppDataContext more easily
export const useAppDataContext = () => {
  const context = useContext(AppDataContext);
  if (!context) {
    throw new Error('useAppDataContext must be used within an AppDataContextProvider');
  }
  return context;
};

// AppDataContextProvider component to wrap around the entire app or relevant parts
export const AppDataContextProvider = ({ apiUrl, children }: { apiUrl: string, children: ReactNode }) => {
  console.log('AppDataContextProvider: apiUrl', apiUrl);
  const [appContext, setAppContext] = useState<AppContext | undefined>(undefined);


  const tokenResolver: Resolver<string> = async (options: ApiRequestOptions): Promise<string> => {
 
   try {
       const token = (await appContext.tokenProvider?.getIdToken());
       return token; 
   } catch (error) {
       console.error('Failed to resolve token:', error);
       return ''; // Return an empty string or handle the error as needed
   }
 };

  useEffect(() => {
    const initAppContext = async () => {
      console.log('initAppContext: getting provider', getConfig('VITE_APP_CONTEXT_PROVIDER'));
      const appContextProvider: AppContextProvider =
        AppContextProviderRegistry.getProvider(getConfig('VITE_APP_CONTEXT_PROVIDER'));

      const appContext: AppContext = await appContextProvider.getAppContext();


      console.log('initAppContext apiUrl', apiUrl);
       // Update the OpenAPI configuration with the new API URL whenever it changes
       OpenAPI.BASE = apiUrl;  // Make sure your OpenAPI client can handle this dynamic update

      setAppContext(appContext);

      // Expose token provider globally for analytics preloader and other services
      (window as any).authProvider = appContext.tokenProvider;
      console.log('✅ Exposed authProvider globally:', !!appContext.tokenProvider);

         // Define the token resolver after appContext is set
         const tokenResolver: Resolver<string> = async (options: ApiRequestOptions): Promise<string> => {
          try {
            console.log('tokenResolver: getting token', appContext.tokenProvider);
            const token = await appContext.tokenProvider?.getIdToken();
            console.log('tokenResolver: token', token);
            return token; 
          } catch (error) {
            console.error('Failed to resolve token:', error);
            return ''; // Return an empty string or handle the error as needed
          }
        };
  
        console.log('configuring OpenAPI');
        // Set the OpenAPI config after defining the tokenResolver
        OpenAPI.WITH_CREDENTIALS = true;
        OpenAPI.CREDENTIALS = 'include';
        OpenAPI.TOKEN = tokenResolver;
    };

    if (!appContext) {
      initAppContext();
    }
  }, []);

  if (!appContext) {
    return <div>Initializing..</div>;
  }

  return (
    <AppDataContext.Provider value={{ appContext, setAppContext, apiUrl }}>
      {children}
    </AppDataContext.Provider>
  );
};